import { v1ApiClient } from '@/services';

export const checkHasAnalysis = async (
  alias: string,
): Promise<{ has_analysis: boolean }> => {
  const res = await v1ApiClient.get(`/charts/${alias}/check-analysis`);
  return res.data;
};
